export enum Screen {
  Home = 'Home',
  Library = 'Library',
  Live = 'Live',
  Calendar = 'Calendar',
}
